import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── 15.2 + 15.17 Astăzi în pădure (live) ── */
export function HomePulseLive() {
  const c = useSectionContent("home_pulse_live");
  const [vital, setVital] = useState(null);
  const [weather, setWeather] = useState(null);
  useEffect(() => {
    api.get("/public/vital-sign").then((r) => setVital(r.data.steps)).catch(() => {});
    api.get("/public/emotional-weather").then((r) => setWeather(r.data.text)).catch(() => {});
  }, []);
  return (
    <section className="py-16 lg:py-20" style={{ background: "linear-gradient(180deg, var(--ct-surface), var(--ct-bg))" }}>
      <div className="max-w-3xl mx-auto px-5 text-center">
        <span data-el="eyebrow" className="eyebrow inline-flex items-center gap-1.5"><Activity size={13} /> <span data-field="eyebrow">{c.eyebrow || "Astăzi în pădure"}</span></span>
        {vital !== null && (
          <h2 data-el="title" className="font-serif text-3xl sm:text-4xl mt-3 mb-3">
            <span style={{ color: "var(--ct-link)" }}><CountUp value={vital} /></span> <span data-field="title_suffix">{c.title_suffix || "pași de vindecare, făcuți împreună"}</span>
          </h2>
        )}
        {weather && <p data-el="subtitle" className="font-serif text-lg leading-snug max-w-xl mx-auto mb-6" style={{ color: "var(--ct-text-muted)" }}>{weather}</p>}
        <Link data-el="cta" data-field="cta" to="/padurea" className="btn-ghost text-sm">{c.cta || "Intră în pădure"} <ArrowRight size={14} /></Link>
      </div>
    </section>
  );
}
